import { render, staticRenderFns } from "./form-content-tag.vue?vue&type=template&id=725b92a1"
import script from "./form-content-tag.vue?vue&type=script&lang=js"
export * from "./form-content-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports